import React from 'react';
import { Typography, Box } from '@material-ui/core';
import { ApolloError } from '@apollo/client';

import { useStyles } from '../styles';
import { Preset } from '../types';
import { generateColorPaletteSet } from '../../../utils/colorHelpers';

import PresetCard from './PresetCard';

interface PresetSelectionProps {
  onSelectPreset: (preset: Preset) => void;
  presets: Preset[];
  loading: boolean;
  error: ApolloError | undefined;
}

const PresetSelection: React.FC<PresetSelectionProps> = ({
  onSelectPreset,
  presets,
  loading,
  error,
}) => {
  const classes = useStyles();

  const colorPalette = generateColorPaletteSet(presets.length);

  if (loading || error) {
    return (
      <div className={classes.content}>
        <Box mb={2} mt={10} style={{ textAlign: 'center' }}>
          <Typography variant="h6">
            {error ? (
              '🤔 Something went wrong... Try reloading the page'
            ) : (
              <span>
                <span className={classes.searchIcon}>🔍</span> Checking for the latests tools...
              </span>
            )}
          </Typography>
        </Box>
      </div>
    );
  }

  return (
    <div className={classes.content} style={{ paddingTop: '240px' }}>
      <div className={classes.presetContainer}>
        {presets.map((preset, index) => (
          <button
            key={`preset-${preset.title}`}
            onClick={() => onSelectPreset(preset)}
            className={classes.presetButton}
            aria-label={`Select ${preset.title || 'preset'}`}
            type="button"
          >
            <PresetCard
              title={preset.title}
              description={preset.description}
              iconName={preset.iconName}
              color={colorPalette[index].textColor}
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default PresetSelection;
